import navigation from "@/lang/fr/navigation";
import generics from "@/lang/fr/generics";
import questions from "@/lang/fr/questions";
import a11y from "@/lang/fr/a11y";
import velt from "@/lang/fr/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
